import { useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { getItemPopupList } from "src/apis/itemApi";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { defaultPRD3011_R01Filter, usePRD3011_R01Store } from "./Store_PRD3011_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";

interface Props {
    onEnterKeyDown: () => void;
}

export const SearchSection_PRD3011_R01 = ({ 
	onEnterKeyDown,
}: Props) => {

	const { PRD3011_R01Filter, setPRD3011_R01Filter } = usePRD3011_R01Store();
	const { compCdList, workPlaceList, yesNoList } = useCommonCodeStore();
    const { setCodeSearchModalProps } = useUiuxStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPos, setPickerPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const productEmpInfoHandleFoucsId = 'infoProductEmpInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
            category: "품목",
            focusId: "itemCd_search",
			responseMapping: {
				itemCd : 'itemCd',
				itemNm : 'itemNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getItemPopupList(code, '', '', '');
				return employeeResponse.data.data.find(value => value.itemCd === code);
			}
        },
		{
			fieldName: 'workEmp',
			category: '담당자',
			focusId: productEmpInfoHandleFoucsId,
			responseMapping: {
				empNo : 'workEmp',
				empNm : 'workEmpNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			}
		},	
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD3011_R01Filter,
		setEditData: setPRD3011_R01Filter,
		defaultData: defaultPRD3011_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD3011_R01_search'
	});

	const expandSearch = () => {
		return (
			<>
				<SearchCodeModalForm
					label="품목코드"
					value={PRD3011_R01Filter.itemCd}
					valueLabel={PRD3011_R01Filter.itemNm}
					onChange={getFieldHandlers('itemCd').onChange}
					onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
					onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
				/>
				<SearchCodeModalForm
					label="사용자"
					value={PRD3011_R01Filter.workEmp}
					valueLabel={PRD3011_R01Filter.workEmpNm}
					handleFoucsId={productEmpInfoHandleFoucsId}
					onChange={getFieldHandlers('workEmp').onChange}
					onDoubleClick={getFieldHandlers('workEmp').onDoubleClick} 
					onKeyDown={getFieldHandlers('workEmp').onEnterKeyDown}
				/>
			</>	
		)
	}

    return (
        <SearchSectionForm expandSearch={expandSearch}>
			<SearchDropDownForm
				label="사업장"
				value={PRD3011_R01Filter.compCd}
				onChangeItem={(item) => setPRD3011_R01Filter({ compCd: item?.compCd || ''})}
				optionList={compCdList}
			/>
			<SearchDateRangeForm
				label="생산 기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[60px] min-w-[60px]',
				}}
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={PRD3011_R01Filter.dateRange}		setDateRange={(dateRange) => setPRD3011_R01Filter({ dateRange })}
				pickerPosition={pickerPos}
				setPickerPosition={setPickerPos}
			/>
			<SearchDropDownForm
				label="공정유형"
				value={PRD3011_R01Filter.workplaceCd || ''}
				optionList={workPlaceList}
				onChangeItem={(selectedItem) => setPRD3011_R01Filter({ workplaceCd: selectedItem?.workplaceCd || '' })}
			/>
			{/* 저장 시 품목 라벨 자동 출력 여부 (Y이면 Content 저장 로직에서 printBulkItemLabel 호출, PRD3010와 동일) */}
			<SearchDropDownForm
				label="Lot라벨자동출력"
				value={PRD3011_R01Filter.labelPrintAuto ?? 'N'}
				onChangeItem={(item) => setPRD3011_R01Filter({ labelPrintAuto: item?.minorCd ?? 'N' })}
				optionList={yesNoList}
				initLabelLess={true}
				wrapperOption={{
					wrapperStyle: "w-[250px] min-w-[250px] mr-[10px]",
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[100px] min-w-[100px]",
					selectStyle: "w-[120px] min-w-[120px] ",
				}}
			/>
        </SearchSectionForm>
    );
};
